const START_LOADING = 'settings/START_LOADING';
const STOP_LOADING = 'settings/STOP_LOADING';

export { START_LOADING, STOP_LOADING };
